module.exports = __webpack_public_path__ + "img/icon-wood.c27b7593.svg";